define((require) => {
    "use strict";

    var ImprovedModel = require("shared/zbone/ImprovedModel"),
        LoggedIn      = require("shared/security/LoggedIn"),
        RestApi       = require("shared/services/RestApi");

    /**
     * Model for the traffic
     *
     * @class TrafficModel
     * @constructor
     */
    return ImprovedModel.extend("Traffic Model", {

        url: function() {
            if (this.has("id")) {
                return RestApi.pathToSpecificResource(RestApi.Collections.TRAFFIC, this.get("id"));
            }
            return RestApi.pathToCollectionOnResource(RestApi.Collections.COMPANIES, LoggedIn.companyId(), RestApi.Collections.TRAFFIC);
        },

        defaults: {
            totalKilobytes: 0,
            daysCount: 0,
            averageKilobytes: 0,
            companyId: null
        }

    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/settings/manageAccount/TrafficModel.js